import React, {FunctionComponent} from 'react';

export type SlideProps = {
    time?: number;
};

export const Slide: FunctionComponent<SlideProps> = (props) => {
    return <>{props.children}</>;
};